import React from 'react';

function formatCurrency(value) {
  if (typeof (value) !== 'number') {
    return '';
  }

  if (typeof Intl === 'object' && Intl && typeof Intl.NumberFormat === 'function') {
    // For right now we only support en-US
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return formatter.format(value);
  }

  return `$${value.toFixed(2)}`
}

export default ({ value, ...props }) => (
  <span {...props}>{formatCurrency(value)}</span>
);
